export const state: State = {
  active: false,
  isLoading: false,
  id: "",
  gatewayPlans: [],
  banks: [],
  documentType: "cnpj",
  documentValue: "",
  name: "",
  bankAccountType: "checking",
  bankId: "",
  agency: "",
  accountDigit: "",
  accountNumber: "",
  errors: {
    documentValue: "",
  },
}
